import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

const defaultState = {
  moderators: [],
  loading: false,
  error: false,
};

const mutations = {
  fetchModerators(state) {
    state.loading = true;
  },
  errorModerators(state) {
    state.moderators = [];
    state.loading = false;
    state.error = true;
  },
  setModerators(state, moderators) {
    state.moderators = moderators;
    state.loading = false;
    state.error = false;
  },
};

const actions = {
  async fetchModerators({ commit }) {
    commit('fetchModerators');
    const response = await backend.getModerators();
    try {
      await checkResponseStatus(200, response);
      const json = response.data;
      commit('setModerators', json);
    } catch (error) {
      commit('errorModerators');
    }
  },

  async deleteModerator({ dispatch }, moderatorID) {
    const response = await backend.deleteModerator(moderatorID);
    await checkResponseStatus(204, response);
    dispatch('fetchModerators');
  },

  async postModerator({ dispatch }, email) {
    const response = await backend.postModerator({ email });
    checkResponseStatus(201, response);
    dispatch('fetchModerators');
  },
};

export default {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
};
